import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/providers/StoreProvider';
import { GameState } from '../types';

import ImgCursor from '@/shared/pictures/cursor.png';

export const Cursor = observer(() => {
    const { userStore,gameStore } = useStore();
    const {gameState} = gameStore;
    const isEnergy = userStore.gameInfo.user.energy > 0;

    if(!(gameState == GameState.init && isEnergy)) {return null}
    return (
      <div className='cursor' onClick={() => gameStore.setGameStart()}>
        <img width={113 * gameStore.scale} src={ImgCursor} alt="cursor" className='cursor-start' />
      </div>
    );

});
